import React from 'react';
import {observer} from "mobx-react";
import {useServices} from "../../hooks/use-services.hook";

interface PortalTypeBasedComponentProps {
    renderForB2C: () => React.ReactElement;
    renderForAgency: () => React.ReactElement;
}

export const PortalTypeBasedComponent: React.FC<PortalTypeBasedComponentProps> = observer((props) => {
    const services = useServices();
    if(services.configuration.isAgencyPortal) {
        return props.renderForAgency();
    } else {
        return props.renderForB2C();
    }
})